// PopoverMenu.jsx
import { Button, Popover } from 'antd';
import React, { useState } from 'react';

const PopoverMenu = ({ content, title, children, id, ...rest }) => {
  const [open, setOpen] = useState(false);

  const onOpenChange = (newOpen) => {
    setOpen(newOpen);
  };

  // Style adjustments for left-aligned content
  const buttonStyle = {
    display: 'flex',
    justifyContent: 'flex-start',
    width: '100%',
    padding: '8px 12px',
    textAlign: 'left',
  };

  const popOverContent = (
    <div
      style={{ display: 'flex', flexDirection: 'column' }}
      onClick={(e) => {
        e.stopPropagation();
      }}
    >
      {content &&
        content.length > 0 &&
        content.map((item, indx) => {
          return (
            <Button
              key={'slug' in item ? item.slug : indx.toString()}
              type="text"
              onClick={(e) => {
                e.stopPropagation();
                item.clickHandler(id);
                setOpen(false);
              }}
              style={buttonStyle} // Apply custom styles
            >
              {item.element}
            </Button>
          );
        })}
    </div>
  );

  return (
    <Popover content={popOverContent} title={title} trigger="click" open={open} onOpenChange={onOpenChange} {...rest}>
      {children}
    </Popover>
  );
};

export default PopoverMenu;
